// export  const API_IMAGE_URL = 'https://app.jsssindia.com/api/uploads/';
// export  const API_IMAGE_URL2 = 'https://app.jsssindia.com/api/';
export  const API_IMAGE_URL = 'https://app.shubhamminfotech.com/api/uploads/';
export  const API_IMAGE_URL2 = 'https://app.shubhamminfotech.com/api/';
// export  const API_IMAGE_URL = 'http://localhost:5000/uploads/';
// export  const API_IMAGE_URL2 = 'http://localhost:5000/';
